var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 11.25C1.76242 11.25 1.48777 11.1358 1.25929 10.9073C1.03082 10.6788 0.916585 10.4042 0.916585 10.0833V2.5H0.333252V1.33333H3.24992V0.75H6.74992V1.33333H9.66658V2.5H9.08325V10.0833C9.08325 10.4042 8.96902 10.6788 8.74054 10.9073C8.51207 11.1358 8.23742 11.25 7.91658 11.25H2.08325ZM7.91658 2.5H2.08325V10.0833H7.91658V2.5ZM3.24992 8.91667H4.41658V3.66667H3.24992V8.91667ZM5.58325 8.91667H6.74992V3.66667H5.58325V8.91667Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5c7f8b0d.svg";
export { ForwardRef as ReactComponent };